"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _area = _interopRequireDefault(require("@/mixins/area"));
var _keyword = _interopRequireDefault(require("@/components/base/keyword.vue"));
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _default2 = require("@/views/scenic-spot/creatProduct/default");
var _mapService = _interopRequireDefault(require("@/utils/mapService"));
var _scenicSpot = require("@/api/scenic-spot");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _vuex = require("vuex");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  mixins: [_area.default],
  //此js存放商品的部分函数方法
  components: {
    Tinymce: _index.default
  },
  data: function data() {
    return {
      labelarr: [],
      form: {
        tags: []
      },
      isEdit: false,
      title: '',
      proTypedialogVisible: false,
      //景区新增弹窗
      rules: {
        image: [{
          required: true,
          message: '请上传景区图片',
          trigger: 'change'
        }],
        sliderImages: [{
          required: true,
          message: '请上传景区详情图',
          type: 'array',
          trigger: 'change'
        }],
        scenicName: [{
          required: true,
          message: '请输入景区名称',
          trigger: 'blur'
        }],
        intro: [{
          required: true,
          message: '请输入景区简介',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['merProductClassify'])),
  mounted: function mounted() {
    if (!localStorage.getItem('merProductClassify') && (0, _permission.checkPermi)(['merchant:product:category:cache:tree'])) this.$store.dispatch('product/getMerProductClassify');
  },
  methods: {
    onInput: function onInput(e) {
      this.$forceUpdate();
    },
    getLabelarr: function getLabelarr(attr) {
      this.form.tags = attr;
    },
    checkPermi: _permission.checkPermi,
    showEdit: function showEdit(row, type) {
      if (row) {
        this.title = '修改景区';
        Object.assign(this.form, JSON.parse(JSON.stringify(row)));
        console.log('Object.assign(this.form, JSON.parse(JSON.stringify(row)))', Object.assign(this.form, JSON.parse(JSON.stringify(row))));

        // 兼容字符串或 JSON 字符串的 sliderImage
        if (typeof this.form.sliderImage === 'string') {
          if (this.form.sliderImage.startsWith('[')) {
            // 是 JSON 字符串格式的数组
            this.form.sliderImages = JSON.parse(this.form.imagePage);
          } else {
            // 是单个 URL 字符串
            this.form.sliderImages = [this.form.imagePage];
          }
        } else {
          this.form.sliderImages = [];
        }
        if (type == 1) {
          this.isEdit = true;
          this.title = '详情';
        } else {
          this.isEdit = false;
        }
        console.log('这里被触发123', this.isEdit, this.form);
        // 响应式丢失，重新赋值
        this.form = _objectSpread(_objectSpread({}, this.form), {}, {
          adjust: [this.form.admissionStartTime, this.form.admissionEndTime],
          officialPhone: this.form.officialPhone,
          sliderImages: JSON.parse(this.form.imagePage)
        });
      } else {
        this.title = '新增景区';
        this.isEdit = false;
        // Object.assign(this.form, JSON.parse(JSON.stringify(defaultArea)))
        this.form = JSON.parse(JSON.stringify(_default2.defaultArea));
        console.log(this.form);
      }
    },
    // handleRemove
    handleRemove: function handleRemove(i) {
      if (!this.isEdit) {
        this.form.sliderImages = this.removeByIndex(this.form.sliderImages, i);
      }
      console.log('删除某一个图片', this.isEdit, i, this.form.sliderImages);
    },
    removeByIndex: function removeByIndex(arr, index) {
      if (index < 0 || index >= arr.length) return arr; // 索引越界保护
      return [].concat(_toConsumableArray(arr.slice(0, index)), _toConsumableArray(arr.slice(index + 1)));
    },
    // 解决修改时间  点确认无效
    adjustChange: function adjustChange(e) {
      console.log('e 解决修改时间  点确认无效', e);
    },
    //选择景区类型确定
    // 保存
    handleSubmit: function handleSubmit() {
      var _this = this;
      this.form.imagePage = JSON.stringify(this.form.sliderImages);
      if (this.form.adjust) {
        this.form.admissionStartTime = this.form.adjust[0];
        this.form.admissionEndTime = this.form.adjust[1];
      }
      this.$refs['formValidate'].validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(valid) {
          var location, result;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!valid) {
                  _context.n = 2;
                  break;
                }
                _context.n = 1;
                return (0, _mapService.default)(_this.form.address);
              case 1:
                location = _context.v;
                if (location && location.lng && location.lat) {
                  result = location.lng ? [String(location.lng), String(location.lat)] : [];
                  console.log('腾讯地图你解析', location);
                  _this.form.location = result;
                }
                if (_this.form.id) {
                  (0, _scenicSpot.areaUpdateApi)(_this.form).then(function (res) {
                    _this.proTypedialogVisible = false;
                    _this.$emit('success');
                    _this.$message.success('修改成功');
                  });
                } else {
                  (0, _scenicSpot.areaCreateApi)(_this.form).then(function (res) {
                    _this.proTypedialogVisible = false;
                    _this.$emit('success');
                    _this.$message.success('新增成功');
                  });
                }
              case 2:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};